<template>
  <etapa-formulario>
    <secao-formulario
      rotulo="Anexos"
      ocultar-rotulo-mobile
      :icone="false"
      :contador-total="totalObrigatorios"
      label-contador="Imagens obrigatórias"
      :contador-atual="anexosObrigatoriosPreenchidos"
    />
    <div class="anexos__upload">
      <input
        multiple
        type="file"
        ref="arquivo"
        class="anexos__input-hidden"
        @change="onSelecionarArquivo"
        accept=".jpg,.jpeg,.png,image/jpeg,image/png"
      />
    </div>

    <transition name="anexos-loader" mode="out-in">
      <div v-if="carregandoGeral" key="carregando" class="text-center py-3">
        <!-- <b-spinner small variant="primary" label="Carregando anexos..." />
        <p class="mt-2 mb-0 text-muted small">Carregando anexos...</p> -->
      </div>
      <div v-else key="galeria" class="anexos__galeria">
        <div class="anexos__grid">
          <!-- CARDS DE UPLOAD / GALERIA -->
          <article
            v-for="item in itensGaleria"
            :key="item.chave"
            class="anexos__card"
            :class="{
              'anexos__card--upload': !item.anexo,
              'anexos__card--leitura': modoVisualizacao,
              'anexos__card--dragover': arrastandoSobre === item.chave,
              'anexos__card--invalido':
                !item.anexo && item.cartao && !!validacao[item.cartao.id],
              'is-invalid':
                !item.anexo && item.cartao && !!validacao[item.cartao.id],
              'anexos__card--opcional':
                (item.cartao && !item.cartao.obrigatorio) ||
                (item.anexo && String(item.anexo.slot).startsWith('extra-')),
              'anexos__card--obrigatorio':
                (item.cartao && item.cartao.obrigatorio) ||
                (item.anexo && ehSlotObrigatorio(item.anexo.slot))
            }"
            :role="item.anexo ? null : 'button'"
            :tabindex="item.anexo ? null : 0"
            :aria-label="item.anexo ? null : item.cartao.rotulo"
            @click="clicarCartao(item)"
            @keydown.enter.prevent="clicarCartao(item)"
            @keydown.space.prevent="clicarCartao(item)"
            @dragover.prevent="sobreCartao(item)"
            @dragleave.prevent="arrastandoSobre = null"
            @drop.prevent="soltarArquivos($event, item)"
          >
            <!-- SLOT VAZIO — zona de upload -->
            <template v-if="!item.anexo">
              <div class="anexos__thumb-wrap anexos__thumb-wrap--vazio">
                <div class="anexos__upload-icon-wrap">
                  <i class="mdi mdi-cloud-upload-outline font-size-24"></i>
                </div>

                <p class="anexos__card-upload-titulo">
                  {{ item.cartao.rotulo }}
                </p>
                <small class="anexos__card-upload-dica"
                  >Clique ou arraste a imagem</small
                >

                <div class="anexos__upload-badges">
                  <span
                    v-if="item.cartao.obrigatorio"
                    class="anexos__badge-obrigatorio"
                    >Obrigatório</span
                  >
                  <span v-else class="anexos__badge-opcional">Opcional</span>
                  <span class="anexos__badge-formato"
                    >JPG, PNG · até 10 MB</span
                  >
                </div>
              </div>
              <div
                v-if="validacao[item.cartao.id]"
                class="invalid-feedback d-block anexos__erro"
              >
                {{ validacao[item.cartao.id] }}
              </div>
            </template>

            <!-- ANEXO CARREGADO -->
            <template v-else>
              <div class="anexos__thumb-wrap">
                <img
                  v-if="ehImagem(item.anexo)"
                  class="anexos__thumb"
                  :src="item.anexo.url"
                  :alt="item.anexo.nome"
                />

                <i
                  v-else
                  class="mdi mdi-file-pdf-box anexos__card-file-icon"
                ></i>

                <div class="anexos__actions-top">
                  <button
                    v-if="ehImagem(item.anexo)"
                    type="button"
                    class="anexos__btn anexos__btn--view"
                    title="Visualizar"
                    aria-label="Visualizar"
                    @click="abrirLightbox(item.anexo)"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </button>
                  <button
                    v-if="!modoVisualizacao"
                    type="button"
                    class="anexos__btn anexos__btn--replace"
                    title="Substituir imagem"
                    aria-label="Substituir imagem"
                    :disabled="
                      item.anexo.statusUpload === 'enviando' ||
                        (item.anexo.statusUpload === 'enviado' &&
                          item.anexo.sqUpload == null) ||
                        (item.anexo.statusUpload === 'erro' &&
                          Number(item.anexo.tentativas) > 0 &&
                          item.anexo.sqUpload == null)
                    "
                    @click.stop="substituir(item.anexo)"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="17 1 21 5 17 9" />
                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                      <polyline points="7 23 3 19 7 15" />
                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                    </svg>
                  </button>
                  <button
                    v-if="!modoVisualizacao && item.anexo.pendenteSubstituicao"
                    type="button"
                    class="anexos__btn anexos__btn--undo"
                    title="Desfazer substituição"
                    aria-label="Desfazer substituição"
                    @click.stop="desfazerSubstituicao(item.anexo)"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="1 4 1 10 7 10" />
                      <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
                    </svg>
                  </button>
                  <button
                    v-if="!modoVisualizacao && !item.anexo.pendenteSubstituicao"
                    type="button"
                    class="anexos__btn anexos__btn--delete"
                    title="Excluir"
                    aria-label="Excluir"
                    :disabled="
                      item.anexo.statusUpload === 'enviando' ||
                        (item.anexo.statusUpload === 'enviado' &&
                          item.anexo.sqUpload == null) ||
                        (item.anexo.statusUpload === 'erro' &&
                          Number(item.anexo.tentativas) > 0 &&
                          item.anexo.sqUpload == null)
                    "
                    @click="excluir(item.anexo)"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="3 6 5 6 21 6" />
                      <path
                        d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                      />
                      <line x1="10" y1="11" x2="10" y2="17" />
                      <line x1="14" y1="11" x2="14" y2="17" />
                    </svg>
                  </button>
                </div>
              </div>

              <div class="anexos__card-body">
                <div class="anexos__meta anexos__meta--inclusao">
                  {{ formatarDataInclusao(item.anexo.dataInclusao) }}
                </div>
                <div class="anexos__name">{{ item.anexo.nome }}</div>
                <div class="anexos__meta">
                  {{ obterExtensaoAquivo(item.anexo.nome) }} · Tamanho:
                  {{ formatSize(item.anexo.tamanho) }}
                </div>
                <div
                  v-if="
                    item.anexo.statusUpload === 'enviando' ||
                      item.anexo.statusUpload === 'erro' ||
                      (item.anexo.statusUpload === 'enviado' &&
                        item.anexo.sqUpload == null)
                  "
                  class="anexos__badges-linha"
                >
                  <span
                    v-if="item.anexo.statusUpload === 'enviando'"
                    class="anexos__badge-status anexos__badge-status--enviando"
                  >
                    <i class="mdi mdi-loading mdi-spin" aria-hidden="true"></i>
                    Enviando…
                  </span>
                  <template v-else-if="item.anexo.statusUpload === 'erro'">
                    <span
                      class="anexos__badge-status anexos__badge-status--erro"
                      :title="item.anexo.erro || 'Falha ao enviar a imagem'"
                    >
                      <i
                        class="mdi mdi-alert-circle-outline"
                        aria-hidden="true"
                      ></i>
                      Falha ao enviar
                    </span>
                    <button
                      type="button"
                      class="anexos__btn-retry"
                      @click.stop="$emit('tentar-novamente', item.anexo)"
                    >
                      Tentar novamente
                    </button>
                  </template>
                  <span
                    v-else
                    class="anexos__badge-status anexos__badge-status--enviado"
                  >
                    <i
                      class="mdi mdi-check-circle-outline"
                      aria-hidden="true"
                    ></i>
                    Enviado, sincronizando…
                  </span>
                </div>
                <span
                  v-if="item.anexo.pendenteSubstituicao"
                  class="anexos__badge-substituicao"
                  title="A troca só vale após clicar em Salvar"
                >
                  Será substituída ao salvar
                </span>
                <span
                  v-if="
                    item.anexo.slot &&
                      !String(item.anexo.slot).startsWith('extra-')
                  "
                  class="anexos__badge-slot"
                  :title="dsTipoAnexoCompleto(item.anexo.slot)"
                >
                  {{ rotuloSlot(item.anexo.slot) }}
                </span>
              </div>
              <div
                v-if="
                  item.anexo.slot &&
                    String(item.anexo.slot).startsWith('extra-')
                "
                class="anexos__tipo-per-anexo p-2"
                @click.stop
              >
                <campo-selecao
                  rotulo="Tipo (opcional)"
                  placeholder="Selecione"
                  :opcoes="tiposAnexoOpcionais"
                  :value="valorTipoAnexo(item.anexo)"
                  :carregando="carregandoTipos"
                  :desabilitado="
                    !tipoOcorrencia ||
                      carregandoTipos ||
                      item.anexo.statusUpload === 'enviando' ||
                      (item.anexo.statusUpload === 'enviado' &&
                        item.anexo.sqUpload == null) ||
                      (item.anexo.statusUpload === 'erro' &&
                        Number(item.anexo.tentativas) > 0 &&
                        item.anexo.sqUpload == null)
                  "
                  no-options-text="Selecione o tipo de ocorrência primeiro."
                  @input="atualizarTipoAnexo(item.anexo, $event)"
                />
                <div
                  v-if="validacao[item.anexo.slot || item.anexo.id]"
                  class="invalid-feedback d-block anexos__erro"
                >
                  {{ validacao[item.anexo.slot || item.anexo.id] }}
                </div>
              </div>
            </template>
          </article>
        </div>
      </div>
    </transition>

    <!-- ============================================================
         LIGHTBOX
         ============================================================ -->
    <div
      class="anexos__lightbox"
      :class="
        lightboxAberto
          ? 'anexos__lightbox--visible'
          : 'anexos__lightbox--hidden'
      "
      @click="fecharLightbox"
    >
      <button class="anexos__lightbox-close" @click.stop="fecharLightbox">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <img
        v-if="lightboxImagem"
        :src="lightboxImagem.url"
        :alt="lightboxImagem.nome"
      />
      <div class="anexos__lightbox-label">
        <span
          v-if="lightboxImagem && lightboxImagem.tipo"
          class="anexos__lightbox-dot"
          :style="{ background: corTipo(lightboxImagem.tipo) }"
        ></span>
        {{ lightboxLabel }}
      </div>
    </div>

    <ConfirmacaoSweetAlert
      v-model="mostrarModalExcluir"
      titulo="Excluir imagem"
      mensagem="Deseja realmente excluir esta imagem? Esta ação não pode ser desfeita."
      texto-confirmar="Excluir"
      texto-cancelar="Cancelar"
      icone="warning"
      :acao-confirmar="confirmarExcluir"
      @cancelar="cancelarExcluir"
    />
  </etapa-formulario>
</template>

<script lang="js">
import EtapaFormulario from "../EtapaFormulario.vue";
import SecaoFormulario from "../SecaoFormulario.vue";
import CampoSelecao from "../campos/CampoSelecao.vue";
import ConfirmacaoSweetAlert from "../ConfirmacaoSweetAlert.vue";
import {
  montarNomeArquivoAnexo,
  montarNomeArquivoOpcional,
  obterProximoSqUploadAnexo
} from "../../utils/nomeArquivoAnexo.js";
import {
  anexoPertenceAoTipoOcorrencia,
  anexoPreencheTipo,
  anexosOpcionais,
  codigoTipoOcorrencia,
  filtrarTiposAnexoOpcionais,
  limiteAnexosOpcionais,
  montarTiposObrigatorios
} from "../../../domain/rules/regrasAnexos.js";

const TAMANHO_MAXIMO = 10 * 1024 * 1024;

const EXTENSOES_PERMITIDAS = [".jpg", ".jpeg", ".png"];

/**
 * Etapa "Anexos" do cadastro de novo relato.
 *
 * Permite anexar imagens (JPG ou PNG até 10MB) via seletor
 * de arquivo ou arrastar-e-soltar, exibindo a galeria de anexos no padrão
 * visual do módulo. Os dados ficam em `value.anexos`.
 *
 * @prop {Object} value - seção do relato (ocorrencia.anexos no container)
 * @prop {Array<{label: string, value: *}>} opcoesSelecione - opções dos selects
 *
 * @emits input   {Object} seção atualizada a cada alteração na lista
 * @emits salvar  {Object} quando salvo com anexos preenchidos
 * @emits proxima quando avançado com anexos preenchidos
 * @emits tentar-novamente {Object} anexo cujo upload em background falhou
 */
import relatoOcorrenciaUseCasesMixin from "../../mixins/relatoOcorrenciaUseCases.mixin.js";

export default {
  name: "Anexos",

  mixins: [relatoOcorrenciaUseCasesMixin],

  inject: {
    modoVisualizacao: {
      type: Boolean,
      default: false
    }
  },

  components: {
    EtapaFormulario,
    SecaoFormulario,
    CampoSelecao,
    ConfirmacaoSweetAlert
  },

  props: {
    value: {
      type: Object,
      required: true
    },

    opcoesSelecione: {
      type: Array,
      default: () => []
    },

    opcoes: {
      type: Object,
      default: () => ({})
    },

    tipoOcorrencia: {
      type: Object,
      default: null
    },

    opcoesTipoAnexo: {
      type: Array,
      default: () => []
    },

    opcoesTipoAnexoObrigatorio: {
      type: Array,
      default: () => []
    },

    carregandoTipos: {
      type: Boolean,
      default: false
    },

    carregandoTiposObrigatorios: {
      type: Boolean,
      default: false
    },

    sqOcorrencia: {
      type: [Number, String],
      default: null
    },

    carregandoAnexos: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      validacao: {},
      arrastandoSobre: null,
      cartaoAtivo: null,
      modoSeletorArquivo: null,
      tipoOcorrenciaAoAbrirSeletor: null,
      seletorArquivoAberto: false,
      lightboxAberto: false,
      lightboxImagem: null,
      mostrarModalExcluir: false,
      anexoExcluir: null,
      excluindoAnexo: false,
      alvoSubstituicao: null,
      seqSubstituicaoTipo: 0,
      cartoesUpload: [
        {
          id: "adesivo-0800",
          rotulo: "Foto do Adesivo 0800",
          obrigatorio: true,
          dsTipoAnexo: "Frota - Foto Adesivo 0800"
        },
        {
          id: "foto-veiculo",
          rotulo: "Foto do Veículo Cooperado",
          obrigatorio: true,
          dsTipoAnexo: "Frota - Foto Veículo Cooperado"
        },
        {
          id: "adicionar-imagem",
          rotulo: "Adicionar imagem",
          obrigatorio: false,
          dinamico: true
        }
      ],

      tiposAnexo: [
        {
          label: "Foto do Local",
          value: "FOTO_LOCAL"
        },
        {
          label: "Foto do Veículo",
          value: "FOTO_VEICULO"
        },
        {
          label: "Documento (CNH/CRLV)",
          value: "DOCUMENTO"
        },
        {
          label: "Comprovante",
          value: "COMPROVANTE"
        }
      ]
    };
  },

  computed: {
    anexos() {
      const anexos = this.value && this.value.anexos;
      return Array.isArray(anexos) ? anexos : [];
    },
    anexosDoTipoAtual() {
      return this.anexos.filter(
        anexo => anexo && this.anexoPertenceAoTipoAtual(anexo)
      );
    },
    carregandoGeral() {
      return !this.anexos.length && !!(
        this.carregandoAnexos ||
        this.carregandoTipos ||
        this.carregandoTiposObrigatorios
      );
    },

    cartoesObrigatoriosEfetivos() {
      return montarTiposObrigatorios({
        tipoOcorrencia: this.tipoOcorrencia,
        tiposObrigatorios: this.opcoesTipoAnexoObrigatorio,
        opcoesTipoAnexo: this.opcoesTipoAnexo
      });
    },

    cartaoGenerico() {
      return this.cartoesUpload.find(c => c.dinamico);
    },

    cartoesUploadEfetivos() {
      const generico = this.cartaoGenerico;
      return generico ? [...this.cartoesObrigatoriosEfetivos, generico] : [...this.cartoesObrigatoriosEfetivos];
    },

    tiposAnexoOpcionais() {
      return filtrarTiposAnexoOpcionais(
        this.opcoesTipoAnexo,
        this.cartoesObrigatoriosEfetivos
      );
    },

    limiteAnexosOpcionais() {
      return limiteAnexosOpcionais(this.tipoOcorrencia);
    },

    anexosOpcionaisAtuais() {
      return anexosOpcionais({
        anexos: this.anexos.filter(
          anexo => anexo && this.anexoPertenceAoTipoAtual(anexo)
        ),
        tipoOcorrencia: this.tipoOcorrencia,
        tiposObrigatorios: this.opcoesTipoAnexoObrigatorio,
        opcoesTipoAnexo: this.opcoesTipoAnexo
      });
    },

    itensGaleria() {
      const obrigatorios = this.cartoesObrigatoriosEfetivos;
      const generico = this.cartaoGenerico;
      const usados = new Set();
      const anexosAtuais = this.anexosDoTipoAtual;

      const itens = obrigatorios.map((cartao, indice) => {
        const indiceAnexo = anexosAtuais.findIndex(
          (anexo, i) => !usados.has(i) && anexoPreencheTipo(anexo, cartao)
        );
        if (indiceAnexo !== -1) usados.add(indiceAnexo);
        return {
          chave: cartao.id || `obrigatorio-${indice + 1}`,
          cartao,
          anexo: indiceAnexo === -1 ? null : anexosAtuais[indiceAnexo]
        };
      });

      anexosAtuais.forEach((anexo, indice) => {
        if (usados.has(indice)) return;
        itens.push({ chave: anexo.id, anexo, cartao: null });
      });

      const podeAdicionarOpcional =
        this.limiteAnexosOpcionais == null ||
        this.anexosOpcionaisAtuais.length < this.limiteAnexosOpcionais;
      if (generico && !this.modoVisualizacao && podeAdicionarOpcional) {
        itens.push({
          chave: `${generico.id}-empty`,
          cartao: generico,
          anexo: null
        });
      }

      return itens;
    },

    lightboxLabel() {
      if (!this.lightboxImagem) return "";
      const tipoLabel = this.tipoLabel(this.lightboxImagem.tipo);
      return this.lightboxImagem.nome + (tipoLabel !== "—" ? "  |  " + tipoLabel : "");
    },

    totalObrigatorios() {
      return this.cartoesObrigatoriosEfetivos.length;
    },

    anexosObrigatoriosPreenchidos() {
      const usados = new Set();
      return this.cartoesObrigatoriosEfetivos.filter(cartao => {
        const indice = this.anexos.findIndex(
          (anexo, i) => !usados.has(i) && anexoPreencheTipo(anexo, cartao)
        );
        if (indice === -1) return false;
        usados.add(indice);
        return true;
      }).length;
    }
  },

  watch: {
    tipoOcorrencia() {
      this.cartaoAtivo = null;
      this.modoSeletorArquivo = null;
      this.alvoSubstituicao = null;
    }
  },

  methods: {
    codigoTipoOcorrenciaAtual() {
      return codigoTipoOcorrencia(this.tipoOcorrencia);
    },

    anexoPertenceAoTipoAtual(anexo) {
      return anexoPertenceAoTipoOcorrencia(anexo, this.tipoOcorrencia);
    },

    podeExcluirAnexo(anexo) {
      if (!anexo || anexo.statusUpload === "enviando") return false;
      if (anexo.statusUpload === "enviado" && anexo.sqUpload == null) {
        return false;
      }
      if (
        anexo.statusUpload === "erro" &&
        Number(anexo.tentativas) > 0 &&
        anexo.sqUpload == null
      ) {
        return false;
      }
      return true;
    },

    // ==============================================================
    // SELEÇÃO DE ARQUIVO
    // ==============================================================

    abrirSeletor(cartaoId = null) {
      if (this.modoVisualizacao) return;
     this.alvoSubstituicao = null;
      this.modoSeletorArquivo = "adicionar";
      this.cartaoAtivo = cartaoId;
      this.tipoOcorrenciaAoAbrirSeletor = this.codigoTipoOcorrenciaAtual();
      this.seletorArquivoAberto = true;
      this.$refs.arquivo.value = "";
      this.$refs.arquivo.click();
    },

    clicarCartao(item) {
      if (this.modoVisualizacao) return;
      if (!item.anexo) this.abrirSeletor(item.cartao.id);
    },

    sobreCartao(item) {
      if (this.modoVisualizacao) return;
      this.arrastandoSobre = item.chave;
    },

    soltarArquivos(event, item) {
      if (this.modoVisualizacao) return;
      this.arrastandoSobre = null;

      const arquivos = event.dataTransfer ? event.dataTransfer.files : [];
      if (item.anexo && arquivos && arquivos.length) {
        this.aplicarSubstituicao(arquivos, item.anexo);
        return;
      }
      if (!item.anexo && item.cartao) {
        this.adicionarArquivos(arquivos, item.cartao.id);
      }
    },

    onSelecionarArquivo(event) {
      if (this.modoVisualizacao) return;
      const tipoAtual = this.codigoTipoOcorrenciaAtual();
      const tipoSeletor = this.tipoOcorrenciaAoAbrirSeletor;
      const seletorAberto = this.seletorArquivoAberto;
      const modoSeletor = this.modoSeletorArquivo;
      const alvoSubstituicao = this.alvoSubstituicao;
      const cartaoId = this.cartaoAtivo;
      this.tipoOcorrenciaAoAbrirSeletor = null;
      this.seletorArquivoAberto = false;
      this.modoSeletorArquivo = null;
      this.cartaoAtivo = null;
      this.alvoSubstituicao = null;
      if (
        seletorAberto &&
        String(tipoSeletor ?? "") !== String(tipoAtual ?? "")
      ) {
        event.target.value = "";
        this.mostrarErro(
          "O tipo de ocorrência mudou. Selecione a imagem novamente no cartão correto."
        );
        return;
      }
      if (modoSeletor === "substituir" && alvoSubstituicao) {
        this.aplicarSubstituicao(event.target.files, alvoSubstituicao);
      } else {
       this.adicionarArquivos(event.target.files, cartaoId);
      }
      event.target.value = "";
    },

    substituir(anexo) {
      if (this.modoVisualizacao || !anexo) return;
      if (anexo.statusUpload === "enviando") return;
      if (anexo.statusUpload === "enviado" && anexo.sqUpload == null) return;
      if (
        anexo.statusUpload === "erro" &&
        Number(anexo.tentativas) > 0 &&
        anexo.sqUpload == null
      ) return;
      this.modoSeletorArquivo = "substituir";
      this.cartaoAtivo = null;
      this.alvoSubstituicao = { id: anexo.id, slot: anexo.slot };
      this.tipoOcorrenciaAoAbrirSeletor = this.codigoTipoOcorrenciaAtual();
      this.seletorArquivoAberto = true;
      this.$refs.arquivo.value = "";
      this.$refs.arquivo.click();
    },

    aplicarSubstituicao(arquivos, alvo) {
      if (this.modoVisualizacao) return;
      const validos = Array.from(arquivos || []).filter(arquivo =>
        this.validarArquivo(arquivo)
      );
      if (!validos.length) return;
      const arquivo = validos[0];
      const lista = [...this.anexos];
      const alvoId = alvo && alvo.id != null ? alvo.id : alvo;
      const indice = lista.findIndex(item => item && alvoId != null && item.id === alvoId);
      if (indice === -1) return;
      const anterior = lista[indice];
      const raizAnterior = anterior.pendenteSubstituicao && anterior.anexoAnterior
        ? anterior.anexoAnterior
        : { ...anterior };
      const dataHoraNome = new Date();
      const sqUploadPrevisto = obterProximoSqUploadAnexo(this.anexos, raizAnterior);
      const nomePadrao = montarNomeArquivoAnexo({
        sqUpload: sqUploadPrevisto,
        sqOcorrencia: this.sqOcorrencia,
        cdPessoaCooperado: this.codigoCooperadoParaNomeAnexo(anterior),
        sqTipoAnexo: this.tipoAnexoParaNome(anterior),
        nomeOriginal: arquivo.name,
        dataHora: dataHoraNome
      });
      const novo = {
        id: `${Date.now()}-subst-${Math.random().toString(36).slice(2, 8)}`,
        nome: nomePadrao || arquivo.name,
        tipo: "",
        tipoArquivo: arquivo.type,
        tamanho: arquivo.size,
        url: URL.createObjectURL(arquivo),
        slot: anterior.slot,
        arquivo,
        tipoAnexo: anterior.tipoAnexo ?? this.value.tipoAnexo ?? null,
        tipoOcorrenciaOrigem: this.codigoTipoOcorrenciaAtual(),
        sqTipoAnexo: anterior.sqTipoAnexo ?? null,
        dsTipoAnexoFull: anterior.dsTipoAnexoFull ?? null,
        rotuloAnexo: anterior.rotuloAnexo ?? null,
        obrigatorioAnexo: anterior.obrigatorioAnexo ?? null,
        dataInclusao: dataHoraNome.toISOString(),
        usuarioInclusao: this.usuarioAtual(),
        pendenteSubstituicao: true,
        anexoAnterior: raizAnterior,
        substituindoSqUpload: raizAnterior.sqUpload ?? null,
        substituicaoExclusaoConfirmada: false
      };
      this.revogarUrlBlob(
        anterior.arquivo && anterior.url && anterior.url !== raizAnterior.url
          ? anterior.url
          : null
      );
      lista.splice(indice, 1, novo);
      this.$delete(this.validacao, novo.slot);
      this.$emit("input", { ...this.value, anexos: lista });
    },

    codigoCooperadoParaNomeAnexo(anexo) {
      const me = this.$store?.state?.me || {};
      return (
        me.cd_pessoa ??
        me.cdPessoa ??
        me.cdPessoaCooperado ??
        me.cd_pessoa_cooperado ??
        anexo?.cdPessoaCooperado ??
        anexo?.cd_pessoa_cooperado ??
        this.value?.cdPessoaCooperado ??
        null
      );
    },

    tipoAnexoParaNome(anexo) {
      const slot = String(anexo?.slot || "").match(/^tipo-(\d+)$/);
      const cartao = this.cartoesObrigatoriosEfetivos.find(
        item => item && item.id === anexo?.slot
      );
      const candidatos = [
        anexo?.sqTipoAnexo,
        anexo?.sq_tipo_anexo,
        anexo?.tipoAnexo?.sqTipoAnexo,
        anexo?.tipoAnexo?.sq_tipo_anexo,
        anexo?.tipoAnexo?.value,
        typeof anexo?.tipoAnexo === "object" ? null : anexo?.tipoAnexo,
        this.value?.tipoAnexo?.sqTipoAnexo,
        this.value?.tipoAnexo?.value,
        typeof this.value?.tipoAnexo === "object"
          ? null
          : this.value?.tipoAnexo,
        slot && slot[1],
        cartao?.sqTipoAnexo,
        cartao?.value
      ];

      const valor = candidatos.find(candidato => {
        if (candidato == null || typeof candidato === "object") return false;
        return /^\d+$/.test(String(candidato).split("|").pop());
      });
      return valor == null ? null : String(valor).split("|").pop();
    },

    desfazerSubstituicao(anexoNovo) {
      if (this.modoVisualizacao || !anexoNovo) return;
      if (!anexoNovo.pendenteSubstituicao) return;
      const lista = [...this.anexos];
      const indice = lista.findIndex(item => item && item.id === anexoNovo.id);
      if (indice === -1 || !anexoNovo.anexoAnterior) return;
      this.revogarUrlBlob(anexoNovo.url);
      lista.splice(indice, 1, { ...anexoNovo.anexoAnterior });
      this.$emit("input", { ...this.value, anexos: lista });
    },

    revogarUrlBlob(url) {
      try {
        if (url && String(url).startsWith("blob:") && typeof URL.revokeObjectURL === "function") {
          URL.revokeObjectURL(url);
        }
      } catch (_e) { void _e; }
    },

    adicionarArquivos(arquivos, cartaoId = null) {
      if (this.modoVisualizacao) return;
      let validos = Array.from(arquivos).filter(arquivo =>
        this.validarArquivo(arquivo)
      );

      if (!validos.length) return;

      const lista = [...this.anexos];
      const cartaoOrigem = this.cartoesUploadEfetivos.find(c => c.id === cartaoId);
      if (cartaoId && !cartaoOrigem) {
        this.mostrarErro(
          "Os cartões de anexo foram atualizados. Selecione a imagem novamente."
        );
        return;
      }

      const criarAnexo = (arquivo, i) => ({
        id: `${Date.now()}-${i}-${Math.random()}`,
        nome: arquivo.name,
        tipo: "",
        tipoArquivo: arquivo.type,
        tamanho: arquivo.size,
        url: URL.createObjectURL(arquivo),
        slot: null,
        arquivo,
        tipoAnexo: this.value.tipoAnexo || null,
        tipoOcorrenciaOrigem: this.codigoTipoOcorrenciaAtual(),
        sqTipoAnexo: null,
        dsTipoAnexoFull: null,
        rotuloAnexo: null,
        obrigatorioAnexo: false,
        dataInclusao: new Date().toISOString(),
        usuarioInclusao: this.usuarioAtual()
      });

      const ehDinamico = !!cartaoOrigem?.dinamico;

      const aplicarSqDoCartao = (anexo, cartao) => {
        if (!cartao) return;
        if (cartao.sqTipoAnexo != null) {
          anexo.sqTipoAnexo = cartao.sqTipoAnexo;
          if (anexo.tipoAnexo == null) anexo.tipoAnexo = cartao.sqTipoAnexo;
        }
        const full = cartao.dsTipoAnexo || (cartao.rotulo ? `Frota - ${cartao.rotulo}` : null);
        if (full) {
          anexo.dsTipoAnexoFull = full;
          anexo.rotuloAnexo = cartao.rotulo || null;
        }
        if (cartao.obrigatorio) anexo.obrigatorioAnexo = true;
      };

      if (ehDinamico) {
        if (this.limiteAnexosOpcionais != null) {
          const disponiveis = Math.max(
            this.limiteAnexosOpcionais - this.anexosOpcionaisAtuais.length,
            0
          );
          if (validos.length > disponiveis) {
            this.mostrarErro("Avaria permite apenas uma imagem opcional.");
          }
          validos = validos.slice(0, disponiveis);
        }
        validos.forEach((arquivo, i) => {
          const anexo = criarAnexo(arquivo, i);
          anexo.slot = `extra-${Date.now()}-${i}-${Math.random().toString(36).slice(2, 6)}`;
          lista.push(anexo);
        });
      } else {
        if (cartaoId) {
          const anexo = criarAnexo(validos[0], 0);
          anexo.slot = cartaoId;
          aplicarSqDoCartao(anexo, cartaoOrigem);

          const posicao = lista.findIndex(
            item =>
              item.slot === cartaoId &&
              this.anexoPertenceAoTipoAtual(item)
          );
          if (posicao !== -1) lista.splice(posicao, 1, anexo);
          else lista.push(anexo);

          validos = validos.slice(1);
          this.$delete(this.validacao, cartaoId);
        }

        const obrigatorios = this.cartoesObrigatoriosEfetivos;
const obrigatoriosOcupados = new Set();
        const indicesUsados = new Set();
        obrigatorios.forEach(cartao => {
          const indice = lista.findIndex(
            (item, indiceItem) =>
              !indicesUsados.has(indiceItem) &&
              anexoPreencheTipo(item, cartao)
          );
          if (indice !== -1) {
            indicesUsados.add(indice);
            obrigatoriosOcupados.add(cartao.id);
          }
        });
        validos.forEach((arquivo, i) => {
          const anexo = criarAnexo(arquivo, i + 1);

          const livre = obrigatorios.find(
            cartao => !obrigatoriosOcupados.has(cartao.id)
          );
          if (livre) {
            anexo.slot = livre.id;
            aplicarSqDoCartao(anexo, livre);
            obrigatoriosOcupados.add(livre.id);
            this.$delete(this.validacao, livre.id);
          } else {
            anexo.slot = `extra-${Date.now()}-${i}-${Math.random().toString(36).slice(2, 6)}`;
            anexo.obrigatorioAnexo = false;
          }

          lista.push(anexo);
        });
      }

      lista.forEach(anexo => {
        if (this.anexos.includes(anexo) || !String(anexo.slot).startsWith("extra-")) return;
        anexo.nome = montarNomeArquivoOpcional(anexo.nome, anexo.id);
      });

      const slotsPreenchidos = new Set(lista.map(item => item.slot).filter(Boolean));
      slotsPreenchidos.forEach(slot => this.$delete(this.validacao, slot));

      this.$emit("input", {
        ...this.value,
        anexos: lista
      });
    },

    validarArquivo(arquivo) {
      if (arquivo.size > TAMANHO_MAXIMO) {
        this.mostrarErro(
          `A imagem "${arquivo.name}" excede o limite de 10MB.`
        );
        return false;
      }

      const extensao = `.${arquivo.name.split(".").pop().toLowerCase()}`;
      if (!EXTENSOES_PERMITIDAS.includes(extensao)) {
        this.mostrarErro(
          `A imagem "${arquivo.name}" deve ser JPG ou PNG.`
        );
        return false;
      }

      return true;
    },

    // ==============================================================
    // EXIBIÇÃO
    // ==============================================================

    ehImagem(anexo) {
      if (!anexo) return false;
      if (anexo.ehImagemApi) return true;
      if (anexo.tipoArquivo && String(anexo.tipoArquivo).startsWith("image/")) return true;
      if (anexo.mime && String(anexo.mime).startsWith("image/")) return true;
      if (anexo.nome && /\.(jpe?g|png|webp|gif|bmp)$/i.test(anexo.nome)) return true;
      return false;
    },

    tipoLabel(tipo) {
      const opcao = this.tiposAnexo.find(item => item.value === tipo);
      return opcao ? opcao.label : "—";
    },

    rotuloSlot(slot) {
      if (!slot) return "";
      if (slot.startsWith("extra-")) return "Imagem adicional";
      const efetivo = this.cartoesObrigatoriosEfetivos.find(cartao => cartao.id === slot);
      if (efetivo) return efetivo.rotulo;
      if (slot === "adesivo-0800") return "Foto do adesivo 0800"; // legado
      const cartao = this.cartoesUpload.find(cartao => cartao.id === slot);
      return cartao ? cartao.rotulo : slot;
    },

    dsTipoAnexoCompleto(slot) {
      if (!slot || slot.startsWith("extra-")) return "";
      const efetivo = this.cartoesObrigatoriosEfetivos.find(cartao => cartao.id === slot);
      return efetivo?.dsTipoAnexo || "";
    },

    ehSlotObrigatorio(slot) {
      if (!slot || String(slot).startsWith("extra-")) return false;
      if (this.cartoesObrigatoriosEfetivos.some(cartao => cartao.id === slot)) return true;
      return ["adesivo-0800", "foto-veiculo"].includes(slot);
    },

    corTipo(tipo) {
      const cores = {
        FOTO_LOCAL: "#dc3545",
        FOTO_VEICULO: "#fd7e14",
        DOCUMENTO: "#0d6efd",
        COMPROVANTE: "#198754"
      };
      return cores[tipo] || "#6c757d";
    },

    formatSize(bytes) {
      if (!bytes) return "";
      if (bytes < 1024) return bytes + " B";
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
      return (bytes / (1024 * 1024)).toFixed(1) + " MB";
    },

    obterExtensaoAquivo(arquivoName) {
      if (!arquivoName) return "ARQUIVO";
      return String(arquivoName).split('.').pop().toUpperCase();
    },

    usuarioAtual() {
      const me = this.$store?.state?.me || {};
      return (
        me.nm_razao ||
        me.nm_pessoa ||
        me.nome ||
        me.name ||
        me.username ||
        me.email ||
        "Usuário atual"
      );
    },

    usuarioAnexo(anexo) {
      if (!anexo) return "—";
      const usuario =
        anexo.usuarioInclusao ??
        anexo.usuario_inclusao ??
        anexo.nmUsuarioInclusao ??
        anexo.nm_usuario_inclusao ??
        anexo.usuario ??
        anexo.user ??
        "";
      if (usuario && typeof usuario === "object") {
        return String(
          usuario.nome ||
          usuario.name ||
          usuario.label ||
          usuario.username ||
          usuario.value ||
          "—"
        );
      }
      return String(usuario || "—");
    },

    formatarDataInclusao(valor) {
      if (!valor) return "—";
      const texto = String(valor).trim();
      if (!texto) return "—";
      const data = new Date(texto.includes(" ") && !texto.includes("T")
        ? texto.replace(" ", "T")
        : texto);
      if (Number.isNaN(data.getTime())) return texto;
      const dois = numero => String(numero).padStart(2, "0");
      return `${dois(data.getDate())}/${dois(data.getMonth() + 1)}/${data.getFullYear()} ${dois(data.getHours())}:${dois(data.getMinutes())}:${dois(data.getSeconds())}`;
    },

    // ==============================================================
    // AÇÕES
    // ==============================================================

    excluir(anexo) {
      if (this.modoVisualizacao) return;
      if (!this.podeExcluirAnexo(anexo)) return;
      this.anexoExcluir = anexo;
      this.mostrarModalExcluir = true;
    },

    confirmarExcluir() {
      const anexo = this.anexoExcluir;
      if (!anexo || this.excluindoAnexo) return;
      if (!this.podeExcluirAnexo(anexo)) {
        this.cancelarExcluir();
        return;
      }
      if (anexo.persistido && anexo.sqUpload != null && this.sqOcorrencia) {
        const sq = this.sqOcorrencia;
        const sqUpload = anexo.sqUpload;
        this.excluindoAnexo = true;
        return this.relatoOcorrenciaUseCases.gerenciarAnexosUseCase.excluir(sq, sqUpload)
          .then(() => {
            const lista = this.anexos.filter(item => item.id !== anexo.id);
            this.$emit("input", { ...this.value, anexos: lista });
            this.$emit("alteracao-salva");
          })
          .catch((e) => {
            const detalhes = e?.response?.data?.errors
              ? Object.values(e.response.data.errors).flat().join(" | ")
              : null;
            this.mostrarErro(
              detalhes || e?.response?.data?.message || "Falha ao excluir o anexo no servidor."
            );
          })
          .finally(() => {
            this.excluindoAnexo = false;
            this.mostrarModalExcluir = false;
            this.anexoExcluir = null;
          });
      }
      const lista = this.anexos.filter(item => item.id !== anexo.id);
      this.revogarUrlBlob(anexo.url);
      this.revogarUrlBlob(anexo.anexoAnterior && anexo.anexoAnterior.url);
      this.$emit("input", {
        ...this.value,
        anexos: lista
      });
      this.mostrarModalExcluir = false;
      this.anexoExcluir = null;
    },

    cancelarExcluir() {
      if (this.excluindoAnexo) return;
      this.mostrarModalExcluir = false;
      this.anexoExcluir = null;
    },

    // ==============================================================
    // LIGHTBOX
    // ==============================================================

    abrirLightbox(anexo) {
      const full = anexo && (
        anexo.thumbDataUrl ||
        anexo.previewUrl ||
        anexo.downloadUrl ||
        anexo.url
      );
      this.lightboxImagem = full ? { ...anexo, url: full } : anexo;
      this.lightboxAberto = true;
    },

    fecharLightbox() {
      this.lightboxAberto = false;
      this.lightboxImagem = null;
    },

    // ==============================================================
    // VALIDAÇÃO / AÇÕES DA ETAPA
    // ==============================================================

    onTipoAnexoChange(valor) {
      this.$emit("input", { ...this.value, tipoAnexo: valor });
    },

    /**
     * @param {Object} anexo - anexo da galeria
     * @returns {Object|null} opção do select
     */
    valorTipoAnexo(anexo) {
      if (!anexo) return null;
      const atual = anexo.tipoAnexo;
      const lista = this.tiposAnexoOpcionais || [];
      const limpar = (ds) => {
        if (ds == null) return "";
        const t = String(ds).trim();
        if (!t) return "";
        const p = t.split(" - ");
        return p.length > 1 ? p[p.length - 1].trim() || t : t;
      };
      if (atual && typeof atual === "object" && "label" in atual) {
        const sqAtual =
          atual.sqTipoAnexo ??
          (atual.value != null ? String(atual.value).split("|").pop() : null);
        const match = lista.find(
          (o) =>
            o &&
            ((sqAtual != null &&
              String(sqAtual).match(/^\d+$/) &&
              (String(o.sqTipoAnexo) === String(sqAtual) ||
                String(o.value).split("|").pop() === String(sqAtual))) ||
              (atual.value != null && String(o.value) === String(atual.value)))
        );
        return match || atual;
      }
      const sq = atual ?? anexo.sqTipoAnexo;
      if (sq != null && String(sq).match(/^\d+$/)) {
        const match = lista.find(
          (o) =>
            o &&
            (String(o.sqTipoAnexo) === String(sq) ||
              String(o.value).split("|").pop() === String(sq))
        );
        if (match) return match;
        const rotulo =
          anexo.rotuloAnexo ||
          limpar(anexo.dsTipoAnexoFull) ||
          `Tipo ${sq}`;
        return {
          value: String(sq),
          label: rotulo,
          sqTipoAnexo: Number(sq),
          dsTipoAnexo: anexo.dsTipoAnexoFull || rotulo
        };
      }
      const texto =
        typeof atual === "string" && atual
          ? atual
          : anexo.dsTipoAnexoFull || anexo.rotuloAnexo || "";
      if (texto) {
        const match = lista.find(
          (o) => o && (o.label === texto || o.dsTipoAnexo === texto)
        );
        if (match) return match;
        return {
          value: texto,
          label: limpar(texto) || texto,
          sqTipoAnexo: anexo.sqTipoAnexo ?? null,
          dsTipoAnexo: texto
        };
      }
      return null;
    },

    async prepararSubstituicaoTipo(anexo, valor, opt, sqSel) {
      const seq = (this.seqSubstituicaoTipo = (this.seqSubstituicaoTipo || 0) + 1);
      const origem =
        anexo.downloadUrl || anexo.previewUrl || anexo.url || anexo.thumbDataUrl;
      if (!origem) {
        this.mostrarErro("Não foi possível preparar a imagem para substituição.");
        return;
      }
      try {
        const blob = await this.relatoOcorrenciaUseCases.gerenciarAnexosUseCase.baixar(origem);
        if (!blob) throw new Error("Falha ao baixar a imagem atual");
        const mime = anexo.tipoArquivo || blob.type || "image/jpeg";
        const arquivo =
          typeof File === "function"
            ? new File([blob], anexo.nome || "anexo.jpg", { type: mime })
            : blob;
        if (seq !== this.seqSubstituicaoTipo) return;
        const anterior = { ...anexo, arquivo: null };
        const url = URL.createObjectURL(arquivo);
        const atualizado = {
          ...anexo,
          id: `${Date.now()}-tipo-${Math.random().toString(36).slice(2, 8)}`,
          tipoAnexo: valor,
          sqTipoAnexo:
            opt && opt.sqTipoAnexo != null
              ? opt.sqTipoAnexo
              : sqSel && /^\d+$/.test(String(sqSel))
              ? Number(sqSel)
              : anexo.sqTipoAnexo,
          dsTipoAnexoFull:
            (opt && (opt.dsTipoAnexo || opt.label)) || anexo.dsTipoAnexoFull,
          rotuloAnexo: (opt && (opt.label || opt.dsTipoAnexo)) || anexo.rotuloAnexo,
          arquivo,
          url,
          pendenteSubstituicao: true,
          anexoAnterior: anterior,
          substituindoSqUpload: anexo.sqUpload,
          substituicaoExclusaoConfirmada: false,
          persistido: false,
          statusUpload: null,
          dataInclusao: new Date().toISOString(),
          usuarioInclusao: this.usuarioAtual()
        };
        const lista = this.anexos.map(item =>
          item.id === anexo.id ? atualizado : item
        );
        if (!lista.some(item => item.id === anexo.id)) {
          this.revogarUrlBlob(url);
          return;
        }
        this.$emit("input", { ...this.value, anexos: lista });
      } catch (_e) {
        if (seq === this.seqSubstituicaoTipo) {
          this.mostrarErro("Não foi possível preparar a imagem para substituição.");
        }
      }
    },

    atualizarTipoAnexo(anexo, valor) {
      const bruto = valor && typeof valor === "object" && "value" in valor ? valor.value : valor;
      const sqSel = bruto != null ? String(bruto).split("|").pop() : null;
      const opcaoSelecionada = (this.opcoesTipoAnexo || []).find(
        (o) => o && (String(o.value) === String(bruto) || (sqSel && (String(o.value).split("|").pop() === sqSel || String(o.sqTipoAnexo) === sqSel)))
      );
      const opt = (this.tiposAnexoOpcionais || []).find(
        o => opcaoSelecionada && String(o.value) === String(opcaoSelecionada.value)
      );
      if (opcaoSelecionada && !opt) {
        this.mostrarErro(
          "Imagem adicional deve usar um tipo diferente das imagens obrigatórias."
        );
        return;
      }
      if (
        anexo &&
        anexo.persistido &&
        !anexo.arquivo &&
        anexo.sqUpload != null
      ) {
        this.prepararSubstituicaoTipo(anexo, valor, opt, sqSel);
        return;
      }
      const lista = this.anexos.map((a) => {
        if (a.id !== anexo.id) return a;
        const next = { ...a, tipoAnexo: valor, obrigatorioAnexo: false };
        if (opt) {
          if (opt.sqTipoAnexo != null) next.sqTipoAnexo = opt.sqTipoAnexo;
          else if (sqSel && sqSel.match(/^\d+$/)) next.sqTipoAnexo = Number(sqSel);
          next.dsTipoAnexoFull = opt.dsTipoAnexo || opt.label || next.dsTipoAnexoFull;
          next.rotuloAnexo = opt.label || next.rotuloAnexo;
        } else if (sqSel && sqSel.match(/^\d+$/)) {
          next.sqTipoAnexo = Number(sqSel);
        }
        return next;
      });
      this.$delete(this.validacao, anexo.slot || anexo.id);
      this.$emit("input", { ...this.value, anexos: lista });
    },

    salvar() {
      if (this.validar({ parcial: true })) {
        this.$emit("salvar", this.value);
      }
    },

    proximaAba() {
      if (this.validar()) {
        this.$emit("proxima");
      }
    },

    validar({ parcial = false } = {}) {
      if (this.modoVisualizacao) return true;
      const erros = {};
      const usados = new Set();
      if (!parcial) {
        this.cartoesObrigatoriosEfetivos.forEach(cartao => {
          const indice = this.anexos.findIndex(
            (anexo, i) => !usados.has(i) && anexoPreencheTipo(anexo, cartao)
          );
          if (indice === -1) {
            erros[cartao.id] = `${cartao.rotulo} é obrigatória`;
          } else {
            usados.add(indice);
          }
        });
      }

      if (
        this.carregandoAnexos ||
        this.carregandoTipos ||
        this.carregandoTiposObrigatorios
      ) {
        erros.carregamento = "Aguarde o carregamento dos tipos de anexo";
      }

      if (
        this.limiteAnexosOpcionais != null &&
        this.anexosOpcionaisAtuais.length > this.limiteAnexosOpcionais
      ) {
        erros[this.cartaoGenerico?.id || "opcionais"] =
          "Avaria permite apenas uma imagem opcional.";
      }

      this.anexosOpcionaisAtuais.forEach(anexo => {
        if (!anexo.arquivo || this.tipoAnexoOpcionalPermitido(anexo)) return;
        erros[anexo.slot || anexo.id] =
          "Imagem adicional deve usar um tipo diferente das imagens obrigatórias.";
      });

      this.validacao = erros;
      return Object.keys(erros).length === 0;
    },

    tipoAnexoOpcionalPermitido(anexo) {
      const tipo = this.valorTipoAnexo(anexo);
      if (!tipo) return true;
      return filtrarTiposAnexoOpcionais(
        [tipo],
        this.cartoesObrigatoriosEfetivos
      ).length > 0;
    },

    mostrarErro(mensagem) {
      this.$bvToast.toast(mensagem, {
        title: "Atenção",
        variant: "warning",
        solid: true
      });
    },

  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/_main";
@import "../../../styles/components/_anexos";
</style>


